import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/subjobs${`?jobId=${number}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/subjobs`;

export const URL = (jobId?: number): RouteDefinition => jobId
	? `${baseRoute}/subjobs?jobId=${jobId}`
	: `${baseRoute}/subjobs`;
